export default {
      id: "ic_chevron_newsletters-usage",
      viewBox: "0 0 18 18",
      url: "../dist/images/" + "sprite.svg#ic_chevron_newsletters-usage",
      toString: function () {
        return this.url;
      }
    }